import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import {
  applySolarSungageApplicationState,
  invalidateSolarSungageDependents,
} from "./solar-sungage-application-cache"
import type {
  SolarSungageApplicationHandoffDto,
  StartSolarSungageApplicationDto,
} from "../dto/solar-sungage.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Start the Sungage application from the current Quote, or recover the open
 * one; a repeat with the same key never opens a second attempt. The server
 * refuses a stale Quote before calling Sungage.
 */
export default function useStartSolarSungageApplication(): UseMutationResult<
  SolarSungageApplicationHandoffDto,
  unknown,
  { proposalId: string; body: StartSolarSungageApplicationDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      solarProposalService.startSungageApplication(proposalId, body),
    onSuccess: (handoff, { proposalId }) =>
      applySolarSungageApplicationState(queryClient, proposalId, handoff),
    onError: (_error, { proposalId }) =>
      invalidateSolarSungageDependents(queryClient, proposalId),
  })
}
